import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", ...props }) => (
  <motion.div
    initial={{ opacity: 0, y: 36 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
    {...props}
  >
    {children}
  </motion.div>
);

export const ChapterHeader = ({ number, eyebrow, title, id }) => (
  <Reveal className="mb-12 lg:mb-16">
    <div className="flex items-baseline gap-4 mb-4">
      <span className="font-mono text-safety text-sm tracking-[0.3em]">{number}</span>
      <span className="h-px flex-1 bg-steelborder" />
      <span className="font-mono text-xs tracking-[0.25em] text-slate-500 uppercase">{eyebrow}</span>
    </div>
    <h2 id={id} className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold uppercase tracking-tight text-slate-100 leading-none">
      {title}
    </h2>
  </Reveal>
);
